import React, { useState } from 'react';
import styles from './login.module.css';
import { cx } from '../../Util/classHelpers';
import EyeIcon from './EyeIcon';

const CustomInput = ({ label, type = 'text', value = '', onChange, disabled = false, error = false, ...rest }) => {
  const [focused, setFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleFocus = () => setFocused(true);
  const handleBlur = () => setFocused(false);
  const handleChange = (e) => {
    if (onChange) onChange(e);
  };

  const inputType = type === 'password' && showPassword ? 'text' : type;
  const hasEyeIcon = type === 'password';

  return (
    <div className={styles.floatingInputRoot}>
      <input
        className={cx(styles.floatingInputField, hasEyeIcon && styles.floatingInputFieldWithEyeIcon, error && styles.floatingInputFieldError)}
        type={inputType}
        value={value}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        disabled={disabled}
        {...rest}
      />
      {hasEyeIcon && (
        <span className={styles.floatingInputEyeIcon}>
          <EyeIcon
            onClick={() => setShowPassword((v) => !v)}
            isVisible={showPassword}
          />
        </span>
      )}
      <label
        className={cx(
          styles.floatingInputLabel,
          (focused || value) && styles.floatingInputLabelFocused
        )}
      >
        {label}
      </label>
    </div>
  );
};

export default CustomInput;
